import { Component } from '@angular/core';


@Component({
  selector: 'app-internal-users',
  templateUrl: './internal-users.component.html',
  styleUrls: ['./internal-users.component.scss'],
})
export class InternalUsersComponent {
  public eventReload: boolean;

  constructor() {}
  receiveMsg(msg: boolean) {
    this.eventReload = msg;    
  }
}
